import { Form } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createAddress,
  deleteAddress,
  fetchFullAddress,
  fetchListAddress,
  fetchProvinces,
  fetchWards,
  updateAddress,
} from '../../../store/actions/address.action';
import { openMessageSuccess } from '../Message/openMessageSuccess';
import { openModalForm } from '../Modal/openModalForm';
import { useTranslation } from 'react-i18next';
import ButtonPrimaryLarge from '../ButtonPrimary/ButtonPrimaryLarge';
import { Divider } from 'antd';
import { openModal } from '../Modal/openModal';
import { Radio } from 'antd';
import ButtonTertiaryLarge from '../ButtonTertiary/ButtonTertiaryLarge';
import { Icon } from '../../icon/icon';
import { cn } from '../../../utils/string/cn.utils';
import Tag from '../Tag/Tag';
import { FormAddress } from '../../../pages/AccountPage/[slug]';
import ButtonSecondaryLarge from '../ButtonSecondary/ButtonSecondaryLarge';
import { openMessageError } from '../Message/openMessageError';
import callApi from '../../../utils/api/callAPI';
import ButtonIconOutlineMedium from '../ButtonIconOutline/ButtonIconOutlineMedium';

const useModalAddress = ({ handleUpdateAddress } = {}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { listAddress, provinces, wards } = useSelector(state => state.address);

  const [listAdd, setListAdd] = useState([]);
  const [deliveryAddress, setDeliveryAddress] = useState(null);

  const watchDeliveryAddress = Form.useWatch('deliveryAddress', form);
  const addAddress = (values, func) => {
    dispatch(createAddress(values)).then(action => {
      if (action.payload?.data) {
        openMessageSuccess({ content: t('Successfully') });
        setDeliveryAddress(action.payload.data);
        func?.();
      }
    });
  };

  const editAddress = (values, func) => {
    dispatch(updateAddress(values))
      .then(action => {
        if (action.payload?.data) {
          form.resetFields();
          openMessageSuccess({ content: t('Successfully') });
          dispatch(fetchListAddress());
          func?.();
        }
      })
      .catch(_ => {
        openMessageError({ content: t('Update address failed') });
      });
  };

  const removeAddress = addressId => {
    dispatch(deleteAddress(addressId))
      .then(action => {
        if (action.payload?.data) {
          form.resetFields();
          openMessageSuccess({ content: t('Successfully') });
          dispatch(fetchListAddress());
        }
      })
      .catch(_ => {
        openMessageError({ content: t('Delete address failed') });
      });
  };

  const getFullAddress = useCallback(
    async ({ street, provinceId, wardId }) => {
      let province = provinces.data.find(
        item => item.province_id?.toString() === provinceId
      );
      let ward = wards.data.find(item => item.wards_id?.toString() === wardId);
      let result = '';

      const baseURL = 'https://partnerdev.viettelpost.vn/v3';
      if (!province) {
        await callApi({
          baseURL,
          endpoint: '/categories/listProvinceNew',
          method: 'GET',
        }).then(res => {
          if (res?.data?.data) {
            province = res.data.data.find(
              item => item.PROVINCE_ID?.toString() === provinceId
            );
          }
        });
      }
      if (!wards) {
        await callApi({
          baseURL,
          endpoint: '/categories/listWardsNew',
          method: 'GET',
          params: {
            provinceId: provinceId,
          },
        }).then(res => {
          if (res?.data?.data) {
            ward = res.data.data.find(
              item => item.WARDS_ID?.toString() === wardId
            );
          }
        });
      }
      if (ward?.WARDS_NAME) {
        result = `${ward.WARDS_NAME}`;
      } else if (ward?.name) {
        result = `${ward.name}`;
      }
      if (province?.PROVINCE_NAME) {
        result = result
          ? `${result}, ${province.PROVINCE_NAME}`
          : province.PROVINCE_NAME;
      } else if (province?.name) {
        result = result ? `${result}, ${province.name}` : province.name;
      }
      // await dispatch(fetchFullAddress({ provinceCode: provinceId, wardCode: wardId })).then(
      //   action => {
      //     if (action.payload?.data) {
      //       const { data } = action.payload;
      //       if (data?.ward?.name && data?.province?.name)
      //         result = `${data.ward?.name}, ${data.province?.name}`;
      //     }
      //   }
      // );
      return street ? `${street}, ${result}` : result;
    },
    [provinces, wards]
  );

  const openModalAddAddress = () => {
    const modal = openModalForm({
      title: (
        <span className="lg:text-headline-small text-title-large !font-bold">
          {t('Add delivery address')}
        </span>
      ),
      width: 800,
      form: <FormAddress form={form} />,
      destroyOnHidden: true,
      afterClose: () => {
        form.resetFields([
          'address_name',
          'contact_name',
          'phone',
          'city',
          'ward',
          'is_default',
        ]);
      },
      footer: (
        <div className="lg:p-[24px] p-[16px] items-end flex justify-end gap-16">
          <ButtonSecondaryLarge
            title={t('Cancel')}
            onClick={() => {
              modal.destroy();
            }}
          />
          <ButtonPrimaryLarge
            title={t('Add address')}
            onClick={() => {
              form
                .validateFields()
                .then(values => {
                  addAddress(values, () => modal.destroy());
                })
                .catch(_ => {});
            }}
          />
        </div>
      ),
      closable: false,
      classNames: {
        header: 'lg:!p-[24px] !p-[16px] m-0',
        body: '!p-0',
        footer: '!mt-[0px]',
        content: '!rounded-[16px]',
      },
    });
  };

  const openModalListAddress = () => {
    const modal = openModal({
      content: (
        <>
          <Divider type="horizontal" className="m-0 !p-0" />
          <FormListAddress form={form} listAdd={listAdd} />
          <Divider type="horizontal" className="m-0 !p-0" />
        </>
      ),
      title: (
        <>
          <span className="lg:text-headline-small text-title-large !font-bold">
            {t('Shipping information')}
          </span>
          <ButtonIconOutlineMedium
            icon={<Icon.ICClose />}
            onClick={() => modal.destroy()}
          />
        </>
      ),
      closable: false,
      footer: (
        <div className="lg:p-[24px] p-[16px] items-end flex justify-between gap-16">
          <ButtonTertiaryLarge
            title={t('Add address')}
            posIcon={<Icon.ICAdd />}
            onClick={() => {
              openModalAddAddress();
            }}
          />
          <ButtonPrimaryLarge
            title={t('Confirm')}
            onClick={() => {
              const addressId = form.getFieldValue('deliveryAddress');
              setDeliveryAddress(listAdd.find(item => item.id === addressId));
              handleUpdateAddress?.(addressId);
              modal.destroy();
            }}
          />
        </div>
      ),
      centered: true,
      width: 800,
      classNames: {
        header:
          'lg:!p-[24px] !p-[16px]] !m-0 [&_.ant-modal-title]:flex [&_.ant-modal-title]:justify-between [&_.ant-modal-title]:items-center',
        body: '!p-0 self-stretch',
        footer: '!mt-[0px]',
      },
    });
  };

  const handleData = useCallback(async () => {
    const items = [];
    for (const item of listAddress.data) {
      const addressFull = await getFullAddress({
        street: item.street,
        provinceId: item.city,
        wardId: item.ward,
      });
      items.push({ ...item, addressFull });
      if (item.is_default && !deliveryAddress) {
        setDeliveryAddress({ ...item, addressFull });
      }

      // if (deliveryAddress?.id === item.id) {
      //   setDeliveryAddress({ ...item, addressFull });
      // }
    }
    setListAdd(items);
  }, [listAddress, deliveryAddress]);

  useEffect(() => {
    if (deliveryAddress?.id) {
      form.setFieldValue('deliveryAddress', deliveryAddress.id);
    }
  }, [deliveryAddress]);

  useEffect(() => {
    if (provinces.isNeedReloadData) {
      dispatch(fetchProvinces());
    }
  }, [provinces.data]);

  useEffect(() => {
    if (wards.isNeedReloadData) {
      dispatch(fetchWards());
    }
  }, [wards.data]);

  return {
    openModalListAddress,
    openModalAddAddress,
    addAddress,
    getFullAddress,
    deliveryAddress,
    setDeliveryAddress,
    listAddress,
    listAdd,
    setListAdd,
    provinces,
    wards,
    form,
    handleData,
    editAddress,
    removeAddress,
  };
};

export default useModalAddress;

const FormListAddress = ({ form, listAdd }) => {
  const watchValue = Form.useWatch('deliveryAddress', form);
  const { t } = useTranslation();

  return (
    <Form form={form}>
      <Form.Item name="deliveryAddress">
        <Radio.Group
          defaultValue={watchValue}
          className="py-[16px] lg:px-[24px] px-[16px] flex flex-col items-start gap-[24px] grow self-stretch"
        >
          {listAdd.map((item, index) => {
            return (
              <div
                key={index}
                className={cn(
                  'card-address flex p-[16px] items-start gap-[16px] self-stretch rounded-[16px] bg-fills-white border-[1px] border-[#E0E0E0] cursor-pointer hover:border-[#006EE5] transition-all duration-200',
                  watchValue === item.id ? 'border-[#006EE5]' : ''
                )}
                onClick={() => {
                  form.setFieldValue('deliveryAddress', item.id);
                }}
              >
                <Radio value={item.id} />
                <div className="flex flex-col items-start self-stretch gap-[12px] grow">
                  <div className="flex justify-between items-center self-stretch">
                    <div className="flex items-center gap-[16px]">
                      <Tag
                        className="bg-[#E3EFFB] text-[#145B90]"
                        label={
                          <span className="text-label-medium">
                            {item.address_name}
                          </span>
                        }
                      />
                      {item.is_default && (
                        <span className="text-label-medium text-[#258FD2] font-semibold">
                          {t('Default address')}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-[8px] grow self-stretch">
                    <span className="text-label-large font-semibold">
                      {item.contact_name}
                    </span>
                    <Divider type="vertical" className="m-0 !p-0" />
                    <span className="text-label-large font-semibold">
                      {item.phone}
                    </span>
                  </div>
                  <span className="text-body-medium">{`${item.addressFull ?? '...'}`}</span>
                </div>
              </div>
            );
          })}
        </Radio.Group>
      </Form.Item>
    </Form>
  );
};
